import { render, staticRenderFns } from "./TypificationActions.vue?vue&type=template&id=42bffd79&scoped=true"
import script from "./TypificationActions.vue?vue&type=script&lang=js"
export * from "./TypificationActions.vue?vue&type=script&lang=js"
import style0 from "./TypificationActions.vue?vue&type=style&index=0&id=42bffd79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bffd79",
  null
  
)

export default component.exports